import React from 'react';
import PropTypes from 'prop-types';
import { Waypoint } from 'react-waypoint';
import { Table } from 'reactstrap';

import DownloadFilesListHeader from './ListHeader';
import DownloadFilesListItem from './ListItem';

const DownloadFilesList = ({
  files,
  selectedFiles,
  loadMore,
  ...props
}) => (
  <div className="files-list">
    <div className="table-wrapper">
      <Table className="files-list download-files-list" responsive>
        <thead>
          <DownloadFilesListHeader
            {...props}
            allFilesSelected={files.length <= selectedFiles.length}
          />
        </thead>
        <tbody>
          {files.map(file => (
            <DownloadFilesListItem
              {...props}
              key={file.uuid}
              file={file}
              fileSelected={selectedFiles.includes(file.uuid)}
            />
          ))}
        </tbody>
      </Table>
      <Waypoint
        bottomOffset="-200px"
        onEnter={loadMore}
      />
    </div>
  </div>
);

DownloadFilesList.propTypes = {
  files: PropTypes.array.isRequired,
  selectedFiles: PropTypes.array.isRequired,
  loadMore: PropTypes.func.isRequired,
};

export default DownloadFilesList;
